import {
  Component,
  ElementRef,
  EventEmitter,
  HostListener, Inject,
  Input,
  OnInit,
  Output, PLATFORM_ID,
  TemplateRef,
  ViewChild
} from '@angular/core';
import { NgbDate, NgbDateParserFormatter, NgbOffcanvas, NgbOffcanvasRef} from '@ng-bootstrap/ng-bootstrap';
import {TranslocoService} from '@ngneat/transloco';
import {
  getDateFromNgbDate,
  getNgbDate
} from '@utility';
import {isPlatformBrowser} from "@angular/common";

@Component({
  selector: 'app-date-range-selector',
  templateUrl: './date-range-selector.component.html',
  styleUrls: ['./date-range-selector.component.scss']
})
export class DateRangeSelectorComponent implements OnInit {

  @Input() largeInput: boolean = false;
  @Input() fromDate: NgbDate | any = null;
  @Input() toDate: NgbDate | any = null;
  @Input() maxDate: NgbDate | undefined;
  @Input() minDate: NgbDate | undefined;
  @Input() wrapperWidth?: string;

  calendarEnd: NgbDate = getNgbDate(30);
  calendarStart: NgbDate = getNgbDate(-30);
  @Output() dateChanged = new EventEmitter<{ from: NgbDate | undefined, to: NgbDate | undefined }>();

  isBrowser: boolean = false;
  navigationDate: Date = new Date()

  opened: boolean = false;
  @ViewChild('dropdownRef', { static: false }) dropdown: any;
  @ViewChild('offcanvasRef') offcanvasTemplate?: TemplateRef<any>;

  constructor(public formatter: NgbDateParserFormatter, private translocoService: TranslocoService, @Inject(PLATFORM_ID) private platformId: Object,
              private offcanvasService: NgbOffcanvas
  ) {
    this.isBrowser = isPlatformBrowser(platformId);
  }

  ngOnInit(): void {
    if (this.maxDate) {
      this.calendarEnd = this.maxDate;
    }
    if (this.minDate) {
      this.calendarStart = this.minDate;
    }
  }

  @HostListener('window:resize')
  onResize() {
    if (this.isBrowser) {
      this.onCalendarClose();
    }
  }

  onOpenDropdown() {
    this.onCalendarClose();
    this.setNavigationDate();
    this.dropdown.open();
  }

  setNavigationDate() {
    const date =
        this.fromDate ? getDateFromNgbDate(this.fromDate) :
            this.toDate ? getDateFromNgbDate(this.toDate) :
                undefined;

    this.navigationDate = date ?? new Date();
  }


  onOpenOffCanvas() {
    if (this.isBrowser) {
      this.setNavigationDate();
      this.onCalendarClose();
      const offcanvasRef: NgbOffcanvasRef = this.offcanvasService.open(
          this.offcanvasTemplate,
          {
            position: 'bottom',
            scroll: false,
            panelClass: 'date-canvas',
            backdropClass: 'date-backdrop',
          }
      );
      offcanvasRef.result.finally(() => (
          this.dateChanged.emit({from: this.fromDate, to: this.toDate})
      ));
    }
  }

  onCalendarClose(): void {
      this.offcanvasService.dismiss();
      this.dropdown.close();
  }

  onRangeChange(data: {from: NgbDate | undefined, to: NgbDate | undefined}) {
      this.fromDate = data.from;
      this.toDate = data.to;
  }


  getValue(): string {
    if (this.fromDate && this.toDate) {
      return (this.formatter.format(this.fromDate) + "-" + this.formatter.format(this.toDate))
    }
    if (!this.fromDate && this.toDate) {
      return this.translocoService.translate("date.range.selector.to") + " " + this.formatter.format(this.toDate)
    }
    if (!this.toDate && this.fromDate) {
      return this.translocoService.translate("date.range.selector.from") + " " + this.formatter.format(this.fromDate)
    }
    return "";
  }

  dropdownClosed(closed: boolean) {
    if (!closed) {
      this.dateChanged.emit({from: this.fromDate, to: this.toDate})
    }
  }
}
